import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { LogoMark } from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="bg-ink min-h-screen flex items-center" data-testid="not-found-page">
      <Seo title="Page Not Found — Dirty Church Chronicles" description="The page you are looking for does not exist." path="/404" />
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-40">
        <LogoMark size={48} className="mb-10" />
        <p className="eyebrow mb-6">404</p>
        <h1 className="font-display font-black uppercase text-paper text-4xl sm:text-6xl tracking-tight mb-6">
          This page has not been written.
        </h1>
        <p className="font-reading text-xl text-paper/60 mb-12">
          The chronicle you are looking for does not exist — or has not been published yet.
        </p>
        <Link to="/" data-testid="not-found-home-link"
          className="inline-flex items-center gap-3 font-ui text-xs uppercase tracking-[0.25em] font-semibold bg-crimson text-paper px-8 py-4 rounded-full transition-[background-color,transform] duration-300 hover:bg-crimsonhi hover:scale-[1.02] active:scale-[0.98]">
          Return Home
        </Link>
      </div>
    </div>
  );
}
